import {Component, AfterViewInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormArray} from '@angular/forms';
import {Organizador} from '../../model/asamblea';
import {functionUtil, functionHelper} from 'src/app/util/functionConst';
import {MatDialog} from '@angular/material/dialog';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

import {RegistroOpcionDialogComponent} from './registro-opcion/registro-opcion-dialog.component';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {IntranetService} from '../../intranet.service';
import {AlertaService} from 'src/app/util/alerta.service';
import {Parametro} from '../../model/parametro';
import {Opcion} from 'src/app/model/opcion';
import * as moment from 'moment';
import {Router, ActivatedRoute} from '@angular/router';
import { O } from '@angular/cdk/keycodes';

@Component({
  selector: 'sura-asamblea',
  templateUrl: './asamblea.component.html',
  styleUrls: ['./asamblea.component.scss']
})
export class AsambleaComponent implements AfterViewInit {
  linkActive = '';
  public asambleaForm: UntypedFormGroup;
  listOrganizadores: Organizador[] = [];
  listTipoParticipante: Parametro[] = [];
  listTipoEnvio: Parametro[] = [];
  listEstado: Parametro[] = [];
  listPlantillaOpcion: Opcion[] = [];
  listTipoPreguntaOpcion: Opcion[] = [];
  idAsamblea: number;

  listTipoQuorum: Parametro[] = [];
  listTipoAsistente: Parametro[] = [];

  listTipoAsamblea: Parametro[] = [];


  disableBtnCancel = true;
  disableBtnAgregar = false;
  disableBtnClone = true;
  disableBtnElimnarPregunta = true;
  disableBtnAgregarPregunta = true;
  disableBtnAgregarPlantilla = true;
  disableBtnSearch = false;
  disableBtnGuardar = true;
  disableBtnEditar = true;
  modoActivo = '';

  minDateInicio: Date = new Date();
  minDateFin: Date = new Date();
  maxDateInicio: Date = new Date(2100, 0, 1);
  maxDateFin: Date = new Date(2100, 0, 1);


  minDateAnticipada: Date = new Date(2000,0,1);
  maxDateAnticipada: Date = new Date();

  maxCaracteresPregunta: number = ParametrosConst.maxCaracteresPregunta;
  maxDateCorte: Date = new Date();
  minDateCorte: Date = new Date();
  estadoCargaLabel = '';

  step = 1;

  selectedTipoPregunta: number[] = [];

  fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnNumericMobile = functionUtil.fnNumericMobile;

  mostrarFechaAnticipada=false;

  verExcelUpload: boolean = true;

  constructor(public dialogRegistroOpcion: MatDialog,
    private intranetService: IntranetService,
    private alertaService: AlertaService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.linkActive = this.router.url;

    this.asambleaForm = new UntypedFormGroup({
      numeroAsamblea: new UntypedFormControl('', [Validators.required]),
      organizador: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      tipoParticipante: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      estado: new UntypedFormControl({value: ParametrosConst.DESCRIPCION_ESTADO_INICIAL, disabled: true}, [Validators.required]),
      tipoAsistencia: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      tipoEnvio: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      tipoQuorum: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      tiempoAsignado: new UntypedFormControl({
        value: null,
        disabled: true
      }, [Validators.required, Validators.min(1), Validators.max(ParametrosConst.MM_MAXIMA)]),
      fechaInicio: new UntypedFormControl({value: new Date(), disabled: true}, [Validators.required]),
      fechaInicioHH: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.HH_MINIMA), Validators.max(ParametrosConst.HH_MAXIMA)]),
      fechaInicioMM: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.MM_MINIMA), Validators.max(ParametrosConst.MM_MAXIMA)]),
      fechaFin: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      fechaFinHH: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.HH_MINIMA), Validators.max(ParametrosConst.HH_MAXIMA)]),
      fechaFinMM: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.MM_MINIMA), Validators.max(ParametrosConst.MM_MAXIMA)]),


      fechaAnticipada: new UntypedFormControl({value: null, disabled: true}, []),
      fechaAnticipadaHH: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.HH_MINIMA), Validators.max(ParametrosConst.HH_MAXIMA)]),
      fechaAnticipadaMM: new UntypedFormControl({
        value: '0',
        disabled: true
      }, [Validators.required, Validators.min(ParametrosConst.MM_MINIMA), Validators.max(ParametrosConst.MM_MAXIMA)]),

      fechaCorte: new UntypedFormControl({value: null, disabled: true}),
      estadoCarga: new UntypedFormControl({value: '0', disabled: true}),
      tipoAsamblea: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      listaPreguntas: this.formBuilder.array([])
    });
    this.cargarCombos();
    this.listarOpciones();
    this.listarTipoPregunta();
  }

  getListPreguntaFormArray() {
    return this.asambleaForm.get('listaPreguntas') as UntypedFormArray;
  }

  agregarPregunta() {
    this.getListPreguntaFormArray().push(this.agregarFormGroup(null, '', null, null, 1, ParametrosConst.MIN_NUM_OPC));
    this.setStep(this.getListPreguntaFormArray().length - 1);
    this.selectedTipoPregunta.push(1);
    

  }

  llenarPreguntas(_arrayPreguntas: any[]) {
    const arrayFormGroup = this.getListPreguntaFormArray();
    for (let index = 0; index < _arrayPreguntas.length; index++) {
      const preguntaBD = _arrayPreguntas[index];
      arrayFormGroup.push(this.agregarFormGroup(
        preguntaBD.id,
        preguntaBD.descripcion,
        preguntaBD.idOpcion,
        preguntaBD.ordenPregunta,
        preguntaBD.tipoPregunta,
        preguntaBD.numOpc));
      this.selectedTipoPregunta.push(preguntaBD.tipoPregunta);
    }
    if (_arrayPreguntas.length > 0) {
      this.setStep(0);
    }
  }
  agregarFormGroup(idPregunta: number, pregunta: string, opcion: number, order: number, tipoPregunta: number, numOpc: number) {

    

    const preguntasGroup: UntypedFormGroup = this.formBuilder.group({});
    if (order == null) {
      order = this.getListPreguntaFormArray().controls.length + 1;
    }
    preguntasGroup.addControl('idPregunta', this.formBuilder.control(idPregunta));
    preguntasGroup.addControl('pregunta', this.formBuilder.control(pregunta, [Validators.required]));
    preguntasGroup.addControl('opcion', this.formBuilder.control(opcion, [Validators.required]));
    preguntasGroup.addControl('orden', this.formBuilder.control(order));
    preguntasGroup.addControl('tipoPregunta', this.formBuilder.control(tipoPregunta, [Validators.required]));
    preguntasGroup.addControl(
      'numOpc',
      this.formBuilder.control(
        numOpc, tipoPregunta === 2 ? [Validators.min(ParametrosConst.MIN_NUM_OPC), Validators.max(ParametrosConst.MAX_NUM_OPC)] : []
      )
    );

    return preguntasGroup;
  }

  
  ngAfterViewInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.idAsamblea = parseInt(params.get('idAsamblea'), 10);
      if (isNaN(this.idAsamblea)) {
        if (params.get('idAsamblea') === 'registrar') {
          this.verExcelUpload = false;
          this.agregarAsamblea();
        }
      } else {
        this.asambleaForm.controls.numeroAsamblea.setValue(this.idAsamblea);
        this.buscarAsamblea();
      }
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  cargarCombos() {
    this.intranetService.listarOrganizadores().then(resultado => {
      if (resultado instanceof Array) {
        this.listOrganizadores = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.intranetService.obtenerParametro(ParametrosConst.TIPO_PARTICIPANTE_ASAMBLEA).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoParticipante = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.intranetService.obtenerParametro(ParametrosConst.TIPO_DE_ENVIO_CORREO_RESULTADOS_DE_VOTACION).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoEnvio = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.intranetService.obtenerParametro(ParametrosConst.ESTADOS_VOTACION_ASAMBLEA).then(resultado => {
      if (resultado instanceof Array) {
        this.listEstado = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });

    this.intranetService.obtenerParametro(ParametrosConst.TIPO_ASISTENCIA_ASAMBLEA).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoAsistente = resultado;
      }
      }).catch(error => {
      this.alertaService.error(error);
    });

    this.intranetService.obtenerParametro(ParametrosConst.TIPO_QUORUM_ASAMBLEA).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoQuorum = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });

     this.intranetService.obtenerParametro(ParametrosConst.TIPO_ASAMBLEA).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoAsamblea = resultado;
      }
      }).catch(error => {
      this.alertaService.error(error);
    });
  }

  buscarAsamblea() {
    if (this.asambleaForm.controls.numeroAsamblea.valid) {
      this.intranetService.buscarAsamblea(this.asambleaForm.value.numeroAsamblea).then((resultado: any) => {
        this.asambleaForm.controls.numeroAsamblea.setValue(resultado.idAsamblea);
        this.asambleaForm.controls.organizador.setValue(resultado.organizador.idOrganizador);
        this.asambleaForm.controls.tipoParticipante.setValue(resultado.tipoParticipante);
        this.asambleaForm.controls.estado.setValue(functionHelper.getDescripcionParametro(resultado.estado, this.listEstado));
        this.asambleaForm.controls.tipoAsistencia.setValue(resultado.tipoAsistencia);

        if(resultado.tipoAsistencia == "H"){
          this.mostrarFechaAnticipada = true;
          const fechaAnticipada = new Date(resultado.fechaAnticipada);
          this.asambleaForm.controls.fechaAnticipada.setValue(moment(fechaAnticipada));
          this.asambleaForm.controls.fechaAnticipadaHH.setValue(fechaAnticipada.getHours());
          this.asambleaForm.controls.fechaAnticipadaMM.setValue(fechaAnticipada.getMinutes());
        }else{
          this.mostrarFechaAnticipada = false;
        }

        this.asambleaForm.controls.tipoEnvio.setValue(resultado.tipoEnvio);
        this.asambleaForm.controls.tiempoAsignado.setValue(resultado.tiempoAsignado);
        const fechaInicio = new Date(resultado.fechaInicio);
        this.asambleaForm.controls.fechaInicio.setValue(moment(fechaInicio));
        this.asambleaForm.controls.fechaInicioHH.setValue(fechaInicio.getHours());
        this.asambleaForm.controls.fechaInicioMM.setValue(fechaInicio.getMinutes());
        const fechaFin = new Date(resultado.fechaFin);
        this.asambleaForm.controls.fechaFin.setValue(moment(fechaFin));
        this.asambleaForm.controls.fechaFinHH.setValue(fechaFin.getHours());
        this.asambleaForm.controls.fechaFinMM.setValue(fechaFin.getMinutes());

        

        const fechaCorte = new Date(resultado.fechaCorte);
        this.asambleaForm.controls.fechaCorte.setValue(moment(fechaCorte));
        this.asambleaForm.controls.estadoCarga.setValue(resultado.estadoCarga);
        this.asambleaForm.controls.tipoQuorum.setValue(resultado.tipoQuorum);
        this.asambleaForm.controls.tipoAsamblea.setValue(resultado.tipoAsamblea);
        this.llenarPreguntas(resultado.listaPreguntas);
        this.iniEdicion(fechaInicio, fechaFin, resultado.estado);
        this.verificarEstadoCarga();
        this.editarAsamblea();
      }).catch(error => {
        this.alertaService.error(error);
      });
    }
  }

  evaluarEdicion(_fechaInicio: Date,
                 _fechaFin: Date,
                 _estado: string) {
    let activarEditar = false;
    const fechaActual = new Date();
    //if (_fechaInicio.getTime() > fechaActual.getTime() && fechaActual.getTime() < _fechaFin.getTime() && (_estado === 'VALIDADO' || _estado === 'V')) {
    if(_estado === 'Pendiente' || _estado === 'P' ||_estado === 'Validado' || _estado === 'V' || _estado === '') {
      activarEditar = true;
      this.disableBtnGuardar = false;
    }
    return activarEditar;
  }

  agregarAsamblea() {
    this.modoActivo = ParametrosConst.CODIGO_ACTION_AGREGAR;
    this.limpiarCampos();
    this.asambleaForm.controls.estado.setValue(ParametrosConst.DESCRIPCION_ESTADO_INICIAL);
    this.asambleaForm.controls.fechaInicio.setValue(moment(new Date()));
    this.asambleaForm.controls.fechaInicioHH.setValue(0);
    this.asambleaForm.controls.fechaInicioMM.setValue(0);
    this.asambleaForm.controls.fechaFinHH.setValue(0);
    this.asambleaForm.controls.fechaFinMM.setValue(0);
    this.asambleaForm.controls.tiempoAsignado.setValue(0);

    this.asambleaForm.controls.fechaAnticipadaHH.setValue(0);
    this.asambleaForm.controls.fechaAnticipadaMM.setValue(0);

    this.minDateInicio = new Date();
    this.habilitarBtn();
    this.deshabilitarBtn();
    this.habilitarBtnPregunta();
    // this.desHabilitarBtnPregunta();
    this.deshabilitarCampos();
    this.habilitarCampos();
    this.agregarPregunta();
  }

  editarAsamblea() {
    const fechaInicio = this.asambleaForm.controls.fechaInicio.value as moment.Moment;
    const fechaFin = this.asambleaForm.controls.fechaFin.value as moment.Moment;
    const estado = this.asambleaForm.controls.estado.value;
    const fechaAnticipada = this.asambleaForm.controls.fechaAnticipada.value as moment.Moment;
    this.iniEdicion(fechaInicio.toDate(), fechaFin.toDate(), estado);
  }

  iniEdicion(_fechaInicio: Date, _fechaFin: Date, _estado: string) {
    this.modoActivo = ParametrosConst.CODIGO_ACTION_EDITAR;
    this.asambleaForm.controls.numeroAsamblea.disable();
    if (this.evaluarEdicion(_fechaInicio, _fechaFin, _estado)) {
      this.habilitarCampos();
      this.minDateInicio = _fechaInicio;
      this.maxDateInicio = _fechaFin;
      this.minDateFin = _fechaInicio;
      this.maxDateAnticipada = _fechaInicio;
      this.habilitarCamposPregunta();
      this.disableBtnEditar = true;
      this.habilitarBtnPregunta();
    } else {
      this.deshabilitarCamposPregunta();
      this.deshabilitarCampos();
    }
    this.deshabilitarBtn();
    this.habilitarBtn();
  }

  cloneAsamblea() {
    this.modoActivo = ParametrosConst.CODIGO_ACTION_CLONAR;
    this.habilitarBtnPregunta();
    this.asambleaForm.controls.numeroAsamblea.reset();
    this.asambleaForm.controls.fechaInicio.setValue(moment(new Date()));
    this.minDateInicio = new Date();
    this.minDateFin = new Date();
    this.asambleaForm.controls.estado.setValue(ParametrosConst.DESCRIPCION_ESTADO_INICIAL);
    this.asambleaForm.controls.fechaInicio.reset();
    this.asambleaForm.controls.fechaInicioHH.reset();
    this.asambleaForm.controls.fechaInicioMM.reset();
    this.asambleaForm.controls.fechaFin.reset();
    this.asambleaForm.controls.fechaFinHH.reset();
    this.asambleaForm.controls.fechaFinMM.reset();

    this.asambleaForm.controls.fechaAnticipada.reset();
    this.asambleaForm.controls.fechaAnticipadaHH.reset();
    this.asambleaForm.controls.fechaAnticipadaMM.reset();

    this.asambleaForm.controls.fechaInicioHH.setValue(0);
    this.asambleaForm.controls.fechaInicioMM.setValue(0);
    this.asambleaForm.controls.fechaFinHH.setValue(0);
    this.asambleaForm.controls.fechaFinMM.setValue(0);

    this.asambleaForm.controls.fechaAnticipadaHH.setValue(0);
    this.asambleaForm.controls.fechaAnticipadaMM.setValue(0);

    this.asambleaForm.controls.fechaCorte.reset();
    this.asambleaForm.controls.estadoCarga.setValue(0);
    this.estadoCargaLabel = ParametrosConst.ESTADO_CARGA_TXT_INICIAL;
    this.deshabilitarCampos();
    this.habilitarCampos();
    this.deshabilitarBtn();
    this.habilitarBtn();
    this.asambleaForm.controls.numeroAsamblea.disable();
    this.habilitarCamposPregunta();
  }

  habilitarBtn() {
    this.disableBtnCancel = false;
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR) {
      this.disableBtnGuardar = false;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnClone = false;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.disableBtnGuardar = false;
    }
  }

  habilitarBtnPregunta() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR || this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.disableBtnAgregarPregunta = false;
      this.disableBtnAgregarPlantilla = false;
      this.disableBtnElimnarPregunta = false;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnAgregarPlantilla = false;
      this.disableBtnAgregarPregunta = false;
      this.disableBtnElimnarPregunta = false;
    }
  }

  desHabilitarBtnPregunta() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR || this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.disableBtnAgregarPregunta = true;
      this.disableBtnAgregarPlantilla = true;
      this.disableBtnElimnarPregunta = true;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnAgregarPlantilla = true;
      this.disableBtnAgregarPregunta = true;
      this.disableBtnElimnarPregunta = true;
    }
  }

  habilitarCampos() {
    this.asambleaForm.controls.fechaInicio.enable();
    this.asambleaForm.controls.fechaInicioHH.enable();
    this.asambleaForm.controls.fechaInicioMM.enable();
    this.asambleaForm.controls.organizador.enable();
    this.asambleaForm.controls.tipoParticipante.enable();
    this.asambleaForm.controls.tipoAsistencia.enable();
    this.asambleaForm.controls.tipoEnvio.enable();
    this.asambleaForm.controls.tiempoAsignado.enable();
    this.asambleaForm.controls.fechaFin.enable();
    this.asambleaForm.controls.fechaFinHH.enable();
    this.asambleaForm.controls.fechaFinMM.enable();

    this.asambleaForm.controls.fechaAnticipada.enable();
    this.asambleaForm.controls.fechaAnticipadaHH.enable();
    this.asambleaForm.controls.fechaAnticipadaMM.enable();

    this.asambleaForm.controls.fechaCorte.enable();
    this.asambleaForm.controls.tipoQuorum.enable();

    this.asambleaForm.controls.tipoAsamblea.enable();
  }

  deshabilitarBtn() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR) {
      this.disableBtnAgregar = true;
      this.disableBtnSearch = true;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnSearch = true;
      this.disableBtnAgregar = true;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.disableBtnClone = true;
      this.disableBtnSearch = true;
    }
  }

  deshabilitarCampos() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR ||
      this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR ||
      this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.asambleaForm.controls.numeroAsamblea.disable();
    }
    this.asambleaForm.controls.organizador.disable();
    this.asambleaForm.controls.tipoParticipante.disable();
    this.asambleaForm.controls.tipoAsistencia.disable();
    this.asambleaForm.controls.tipoEnvio.disable();
    this.asambleaForm.controls.tiempoAsignado.disable();
    this.asambleaForm.controls.fechaInicio.disable();
    this.asambleaForm.controls.fechaInicioHH.disable();
    this.asambleaForm.controls.fechaInicioMM.disable();
    this.asambleaForm.controls.fechaFin.disable();
    this.asambleaForm.controls.fechaFinHH.disable();
    this.asambleaForm.controls.fechaFinMM.disable();

    this.asambleaForm.controls.fechaAnticipada.disable();
    this.asambleaForm.controls.fechaAnticipadaHH.disable();
    this.asambleaForm.controls.fechaAnticipadaMM.disable();

    this.asambleaForm.controls.fechaCorte.disable();
    this.asambleaForm.controls.tipoQuorum.disable();

    this.asambleaForm.controls.tipoAsamblea.disable();
  }

  deshabilitarCamposPregunta() {
    const preguntas = this.asambleaForm.controls.listaPreguntas as UntypedFormArray;
    preguntas.controls.forEach(pregunta => {
      const control = pregunta as UntypedFormGroup;
      control.controls['opcion'].disable();
      control.controls['pregunta'].disable();
      control.controls['tipoPregunta'].disable();
      control.controls['numOpc'].disable();
    });
  }

  habilitarCamposPregunta() {
    const preguntas = this.asambleaForm.controls.listaPreguntas as UntypedFormArray;
    preguntas.controls.forEach(pregunta => {
      const control = pregunta as UntypedFormGroup;
      control.controls['opcion'].enable();
      control.controls['pregunta'].enable();
      control.controls['tipoPregunta'].enable();
      control.controls['numOpc'].enable();
    });
  }

  cancelarOperacion() {
    this.disableBtnCancel = true;
    this.disableBtnGuardar = true;
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR) {
      this.disableBtnAgregar = false;
      this.disableBtnSearch = false;
      this.disableBtnAgregarPregunta = true;
      this.disableBtnAgregarPlantilla = true;
      this.disableBtnElimnarPregunta = true;
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnClone = true;
      this.disableBtnAgregar = false;
      this.disableBtnSearch = false;
      this.desHabilitarBtnPregunta();
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
      this.disableBtnClone = true;
      this.disableBtnAgregar = false;
      this.disableBtnSearch = false;
      this.disableBtnAgregarPregunta = true;
      this.disableBtnAgregarPlantilla = true;
      this.disableBtnElimnarPregunta = true;
    }
    this.deshabilitarCampos();
    this.asambleaForm.controls.numeroAsamblea.enable();
    this.limpiarCampos();
  }

  limpiarCampos() {
    this.asambleaForm.reset();
    const arr = this.getListPreguntaFormArray();
    const maxFor = arr.length;
    for (let index = 0; index < maxFor; index++) {
      arr.removeAt(0);
    }
    this.asambleaForm.controls['estado'].setValue(ParametrosConst.DESCRIPCION_ESTADO_INICIAL);
    this.asambleaForm.controls['estadoCarga'].setValue(ParametrosConst.CERO);
    this.estadoCargaLabel = '';
    this.selectedTipoPregunta = [];
  }

  mostrarModalAgregarPlantillaOpciones() {
    const dialogRef = this.dialogRegistroOpcion.open(RegistroOpcionDialogComponent, {
      width: '650px',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.listarOpciones();
      }
    });
  }

  eliminarPregunta(_index: number) {
    if (_index >= 0 && this.validarPregunta(ParametrosConst.CODIGO_ACTION_ELIMINAR)) {
      this.getListPreguntaFormArray().removeAt(_index);
      this.selectedTipoPregunta.splice(_index, 1);
    }
    this.reordenarPreguntas();
  }

  validarPregunta(_accion: string) {
    let valido = true;
    if (ParametrosConst.CODIGO_ACTION_ELIMINAR === _accion && this.getListPreguntaFormArray().controls.length <= 1) {
      alert(ParametrosConst.MSJ_PREGUNTA_MIN_ELIMINAR);
      valido = false;
    }
    return valido;
  }

  permitirAgregarPregunta() {
    return this.getListPreguntaFormArray().controls.length < ParametrosConst.maxPreguntasPermitidas &&
      (!this.disableBtnAgregarPregunta);
  }

  reordenarPreguntas() {
    const array = this.getListPreguntaFormArray().controls;
    for (let index = 0; index < array.length; index++) {
      const element = array[index] as UntypedFormGroup;
      element.controls.orden.setValue(index + 1);
    }
  }

  listarOpciones() {
    this.intranetService.obtenerOpciones().then(respuesta => {
      if (respuesta instanceof Array) {
        this.listPlantillaOpcion = [];
        for (let index = 0; index < respuesta.length; index++) {
          const opcion = new Opcion();
          opcion.id = respuesta[index].id;
          opcion.descripcion = respuesta[index].descripcion;
          this.listPlantillaOpcion.push(opcion);
        }
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }
  listarTipoPregunta() {
    // TODO: obtener tipo de pregunta de servicio
    this.listTipoPreguntaOpcion = [];

    const opcion = new Opcion();
    opcion.id = 1;
    opcion.descripcion = 'Simple';
    this.listTipoPreguntaOpcion.push(opcion);

    const opcion2 = new Opcion();
    opcion2.id = 2;
    opcion2.descripcion = 'Múltiple';
    this.listTipoPreguntaOpcion.push(opcion2);
  }
  // _fechaInicio : string = null;
  hasError(controlName: string) {
    return this.asambleaForm.controls[controlName].invalid;
  }

  hasErrorPreguntas(controlName: string, index: number) {
    const preArray = this.asambleaForm.controls.listaPreguntas as UntypedFormArray;
    const control = preArray.controls[index] as UntypedFormGroup;
    return control.controls[controlName].invalid;
  }

  obtenerMensajeErrorPreguntas(controlName: string, index: number) {
    return functionHelper.extraerErrorArray(this.asambleaForm.controls.listaPreguntas as UntypedFormArray, index, controlName);
  }

  obtenerMensajeError(controlName: string) {
    return functionHelper.extraerErrorGroup(this.asambleaForm, controlName);
  }

  desactivarBtnGuardar() {
    return this.disableBtnGuardar || this.asambleaForm.invalid;
  }

  guardarAsamblea() {
    try {
      if (this.asambleaForm.invalid) {
        return false;
      }
      const objAsamblea: any = this.asambleaForm.getRawValue();

      const fechaInicio = objAsamblea.fechaInicio.toDate();
      fechaInicio.setHours(objAsamblea.fechaInicioHH);
      fechaInicio.setMinutes(objAsamblea.fechaInicioMM);
      const fechaFin = objAsamblea.fechaFin.toDate();
      fechaFin.setHours(objAsamblea.fechaFinHH);
      fechaFin.setMinutes(objAsamblea.fechaFinMM);

      let fechaString = null;
      if(objAsamblea.tipoAsistencia == 'H'){
        const fechaAnticipada = objAsamblea.fechaAnticipada.toDate();
        fechaAnticipada.setHours(objAsamblea.fechaAnticipadaHH);
        fechaAnticipada.setMinutes(objAsamblea.fechaAnticipadaMM);
        // const fechaCorte = objAsamblea.fechaCorte.toDate();
        fechaString = fechaAnticipada.getTime();
      }

      const objGuardar = {
        idOrganizador: objAsamblea.organizador,
        tipoParticipante: objAsamblea.tipoParticipante,
        estado: ParametrosConst.AGREGAR_ESTADO_INICIAL,
        tipoAsistencia: objAsamblea.tipoAsistencia,
        tipoEnvio: objAsamblea.tipoEnvio,
        tiempoAsignado: objAsamblea.tiempoAsignado,
        estadoCarga: objAsamblea.estadoCarga,
        fechaInicio: fechaInicio.getTime(),
        fechaFin: fechaFin.getTime(),
        tipoQuorum: objAsamblea.tipoQuorum,
        fechaAnticipada: fechaString,
        tipoAsamblea: objAsamblea.tipoAsamblea
      };

      if (objAsamblea.listaPreguntas instanceof Array) {
        const array = [];
        objAsamblea.listaPreguntas.forEach(pregunta => {
          const obj = {
            'ordenPregunta': pregunta.orden,
            'idOpcion': pregunta.opcion,
            'descripcion': pregunta.pregunta,
            'tiempoAsignado': objGuardar.tiempoAsignado,
            'tipoPregunta': pregunta.tipoPregunta,
            'numOpc': pregunta.numOpc
          };
          if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
            obj['id'] = pregunta.idPregunta;
          }
          array.push(obj);
        });
        objGuardar['listaPreguntas'] = array;
      }
      if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
        objGuardar['idAsamblea'] = objAsamblea.numeroAsamblea;

        const jsonData = objGuardar // tu JSON
        const formData = new FormData();
        if (this.file) {
         formData.append("file", this.file);
        }      
        formData.append("asamblea", JSON.stringify(jsonData));
        this.intranetService.modificarAsamblea(formData).then((resultado: any) => {
          this.alertaService.success(resultado.obj);
          this.buscarAsamblea();
          this.verificarEstadoCarga();
          setTimeout(() => {
            this.router.navigate(['/mntAsamblea'], {queryParams: {}});
          }, 1500);
        }).catch(error => {
          this.alertaService.error(error);
        });
      } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR || this.modoActivo === ParametrosConst.CODIGO_ACTION_CLONAR) {
        this.intranetService.guardarAsamblea(objGuardar).then((resultado: any) => {
          this.alertaService.success(resultado.obj);
          this.asambleaForm.controls.numeroAsamblea.setValue(resultado.idAsamblea);
          this.deshabilitarBtn();
          this.deshabilitarCampos();
          this.deshabilitarCamposPregunta();
          this.disableBtnGuardar = true;
          this.disableBtnCancel = false;
          // this.disableBtnEditar = false;
          this.desHabilitarBtnPregunta();
          this.verificarEstadoCarga();
          setTimeout(() => {
            this.router.navigate(['/mntAsamblea'], {queryParams: {}});
          }, 1500);
        }).catch(error => {
          this.alertaService.error(error);
        });
      }
    } catch (error) {
      this.alertaService.error(error);
    }
  }

  formatearResumenPregunta(object: UntypedFormGroup, step: number) {
    return object.controls.pregunta.value === null ? '' : object.controls.pregunta.value;
    /*
    return object.controls['pregunta'].value === null ? "| :
      object.controls['pregunta'].value.length > 90 ? object.controls['pregunta'].value.substring(0, 90) + "..." :
        object.controls['pregunta'].value;
    */
  }

  validarFechaToyDay() {
    if (this.equalsFechaInicioFin()) {
      // mismo dia
      /*this.asambleaForm.controls['fechaInicioHH'].setValue('0');
      this.asambleaForm.controls['fechaInicioMM'].setValue('0');*/
      this.asambleaForm.controls.fechaFinHH.setValue('23');
      this.asambleaForm.controls.fechaFinMM.setValue('59');
      this.validarFechaToyDayEqualHours();
    } else {
      this.asambleaForm.controls.fechaFinHH.setValidators(
        [Validators.required, Validators.min(ParametrosConst.HH_MINIMA), Validators.max(ParametrosConst.HH_MAXIMA)]);
      this.asambleaForm.controls.fechaFinMM.setValidators(
        [Validators.required, Validators.min(ParametrosConst.MM_MINIMA), Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaInicioHH.setValidators(
        [Validators.required, Validators.min(ParametrosConst.HH_MINIMA), Validators.max(ParametrosConst.HH_MAXIMA)]);
      this.asambleaForm.controls.fechaInicioMM.setValidators(
        [Validators.required, Validators.min(ParametrosConst.MM_MINIMA), Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaFinHH.updateValueAndValidity();
      this.asambleaForm.controls.fechaFinMM.updateValueAndValidity();
      this.asambleaForm.controls.fechaInicioHH.updateValueAndValidity();
      this.asambleaForm.controls.fechaInicioMM.updateValueAndValidity();
      /*this.asambleaForm.controls['fechaInicioHH'].setValue('0');
      this.asambleaForm.controls['fechaInicioMM'].setValue('0');*/
      this.asambleaForm.controls.fechaFinHH.setValue('0');
      this.asambleaForm.controls.fechaFinMM.setValue('0');
    }
  }

  equalsFechaInicioFin() {
    return this.asambleaForm.controls.fechaFin.value != null &&
      this.asambleaForm.controls.fechaInicio.value != null &&
      (this.asambleaForm.controls.fechaFin.value.format('DD/MM/YYYY') ===
        this.asambleaForm.controls.fechaInicio.value.format('DD/MM/YYYY'));
  }

  equalsHoraInicioAndFin() {
    return this.asambleaForm.controls.fechaInicioHH.value != null &&
      this.asambleaForm.controls.fechaFinHH.value != null &&
      (this.asambleaForm.controls.fechaInicioHH.value
        === this.asambleaForm.controls.fechaFinHH.value);
  }

  validarFechaToyDayEqualHours() {
    if (this.equalsHoraInicioAndFin()) {
      this.asambleaForm.controls.fechaInicioMM.setValue('0');
      this.asambleaForm.controls.fechaFinMM.setValue('59');
    }
  }

  changeFechaInicio(event: MatDatepickerInputEvent<moment.Moment>) {
    this.minDateFin = event.value.toDate();
    this.maxDateCorte = event.value.toDate();
    this.maxDateAnticipada = event.value.toDate();
    this.validarFechaToyDay();
  }

  changeFechaFin(event: MatDatepickerInputEvent<moment.Moment>) {
    this.maxDateInicio = event.value.toDate();
    this.validarFechaToyDay();
  }

  changeFechaAnticipada(event: MatDatepickerInputEvent<moment.Moment>) {
    this.maxDateAnticipada = event.value.toDate();
    this.validarFechaToyDay();
  }

  changeFechaInicioHH(event) {
    if (this.equalsFechaInicioFin()) {
      this.asambleaForm.controls.fechaFinHH.setValidators([
        Validators.required,
        Validators.min(this.controlHHCorrecta(Number.parseFloat(event.target.value), event)),
        Validators.max(ParametrosConst.HH_MAXIMA)]);
      this.asambleaForm.controls.fechaFinHH.updateValueAndValidity();
    }
    this.validarFechaToyDayEqualHours();
  }

  changeFechaInicioMM(event) {
    if (this.equalsHoraInicioAndFin()) {
      this.asambleaForm.controls.fechaFinMM.setValidators([
        Validators.required,
        Validators.min(this.controlMMCorrecta(Number.parseFloat(event.target.value),
          event)), Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaFinMM.updateValueAndValidity();
    } else {
      this.asambleaForm.controls.fechaFinMM.setValidators([
        Validators.required,
        Validators.min(ParametrosConst.MM_MINIMA),
        Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaFinMM.updateValueAndValidity();
    }
  }

  changeFechaFinHH(event) {
    if (this.equalsFechaInicioFin()) {
      this.asambleaForm.controls.fechaInicioHH.setValidators([
        Validators.required,
        Validators.max(this.controlHHCorrecta(Number.parseFloat(event.target.value), event)),
        Validators.min(ParametrosConst.HH_MINIMA)]);
      this.asambleaForm.controls.fechaInicioHH.updateValueAndValidity();
    }
    this.validarFechaToyDayEqualHours();
  }

  changeFechaAnticipadaHH(event) {
    if (this.equalsFechaInicioFin()) {
      this.asambleaForm.controls.fechaAnticipadaHH.setValidators([
        Validators.required,
        Validators.max(this.controlHHCorrecta(Number.parseFloat(event.target.value), event)),
        Validators.min(ParametrosConst.HH_MINIMA)]);
      this.asambleaForm.controls.fechaAnticipadaHH.updateValueAndValidity();
    }
    this.validarFechaToyDayEqualHours();
  }

  changeFechaFinMM(event) {
    if (this.equalsHoraInicioAndFin()) {
      this.asambleaForm.controls.fechaInicioMM.setValidators([
        Validators.required,
        Validators.max(this.controlMMCorrecta(Number.parseFloat(event.target.value), event)),
        Validators.min(ParametrosConst.MM_MINIMA)]);
      this.asambleaForm.controls.fechaInicioMM.updateValueAndValidity();
    } else {
      this.asambleaForm.controls.fechaInicioMM.setValidators([
        Validators.required,
        Validators.min(ParametrosConst.MM_MINIMA),
        Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaInicioMM.updateValueAndValidity();
    }
  }


  changeFechaAnticipadaMM(event) {
    if (this.equalsHoraInicioAndFin()) {
      this.asambleaForm.controls.fechaAnticipadaMM.setValidators([
        Validators.required,
        Validators.max(this.controlMMCorrecta(Number.parseFloat(event.target.value), event)),
        Validators.min(ParametrosConst.MM_MINIMA)]);
      this.asambleaForm.controls.fechaAnticipadaMM.updateValueAndValidity();
    } else {
      this.asambleaForm.controls.fechaAnticipadaMM.setValidators([
        Validators.required,
        Validators.min(ParametrosConst.MM_MINIMA),
        Validators.max(ParametrosConst.MM_MAXIMA)]);
      this.asambleaForm.controls.fechaAnticipadaMM.updateValueAndValidity();
    }
  }

  controlHHCorrecta(hora: number, event) {
    if (hora > ParametrosConst.HH_MAXIMA) {
      return ParametrosConst.HH_MAXIMA;
    }
    if (hora < ParametrosConst.HH_MINIMA) {
      return ParametrosConst.HH_MAXIMA;
    }
    return hora;
  }

  controlMMCorrecta(minuto: number, event) {
    if (minuto > ParametrosConst.MM_MAXIMA) {
      return ParametrosConst.MM_MAXIMA;
    }
    if (minuto < ParametrosConst.MM_MINIMA) {
      return ParametrosConst.MM_MAXIMA;
    }
    return minuto;
  }

  verificarEstadoCarga() {
    const estadoCargaValue = this.asambleaForm.controls.estadoCarga.value;
    if (ParametrosConst.UNO === estadoCargaValue) {
      this.estadoCargaLabel = ParametrosConst.ESTADO_CARGA_TXT_CARGADO;
    } else {
      this.estadoCargaLabel = ParametrosConst.ESTADO_CARGA_TXT_INICIAL;
    }
  }
  changeOpcion(event, i) {
    const tipoPregunta = (this.getListPreguntaFormArray().controls[i] as UntypedFormGroup).controls['tipoPregunta'].value;
    if (tipoPregunta === 2) {
      const max = this.listPlantillaOpcion.find(ele => ele.id === event.value).descripcion.split(',').length;
      (this.getListPreguntaFormArray().controls[i] as UntypedFormGroup).controls['numOpc'].setValidators(
        [Validators.required, Validators.min(ParametrosConst.MIN_NUM_OPC), Validators.max(max)]
      );
      (this.getListPreguntaFormArray().controls[i] as UntypedFormGroup).controls['numOpc'].updateValueAndValidity();
    } else {
      (this.getListPreguntaFormArray().controls[i] as UntypedFormGroup).controls['numOpc'].setValidators([]);
      (this.getListPreguntaFormArray().controls[i] as UntypedFormGroup).controls['numOpc'].updateValueAndValidity();
    }
  }
  onSelectTipoPregunta(i) {
    const arr = this.getListPreguntaFormArray().value;
    const tipoPregunta = arr[i]['tipoPregunta'];
    if (tipoPregunta !== 2) {
      arr[i]['numOpc'] = 0;
    }
  }

  selectTipoAsistencia(item){
    console.log(item);
    if(item == "H"){
      this.asambleaForm.controls.fechaAnticipada.setValidators([Validators.required]);
      this.asambleaForm.controls.fechaAnticipadaHH.setValidators([Validators.required]);
      this.asambleaForm.controls.fechaAnticipadaMM.setValidators([Validators.required]);
      this.asambleaForm.controls.fechaAnticipada.updateValueAndValidity();
      this.asambleaForm.controls.fechaAnticipadaHH.updateValueAndValidity();
      this.asambleaForm.controls.fechaAnticipadaMM.updateValueAndValidity();
      this.mostrarFechaAnticipada = true;
    }else{
      this.asambleaForm.controls.fechaAnticipada.setValidators([]);
      this.asambleaForm.controls.fechaAnticipadaHH.setValidators([]);
      this.asambleaForm.controls.fechaAnticipadaMM.setValidators([]);
      this.asambleaForm.controls.fechaAnticipada.updateValueAndValidity();
      this.asambleaForm.controls.fechaAnticipadaHH.updateValueAndValidity();
      this.asambleaForm.controls.fechaAnticipadaMM.updateValueAndValidity();
      this.mostrarFechaAnticipada = false;
    }

  }

  file: File | null = null;
fileName: string = "";

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    const ext = selectedFile.name.split('.').pop().toLowerCase();
    if (ext !== 'xls' && ext !== 'xlsx') {
      alert("Solo se permiten archivos Excel (.xls, .xlsx)");
      return;
    }

    this.file = selectedFile;
    this.fileName = selectedFile.name;
  }
}
